module.exports = __webpack_public_path__ + "static/media/photo-left-second.8d2d4540.png";